(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9396],{

/***/ 94217:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy-policy",
      function () {
        return __webpack_require__(8687);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ privacy_policy; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./blocks/PrivacyPolicyItem/PrivacyPolicyItem.tsx

var PrivacyPolicyItem = function(param) {
    var title = param.title, privacyPolicies = param.privacyPolicies;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "privacy-policy-list",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                className: "privacy-policy-list_title",
                children: title
            }),
            privacyPolicies && privacyPolicies.map(function(listItem, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "privacy-policy-list_item",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "privacy-policy-list_description",
                            children: listItem.description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                            children: listItem.innerList && listItem.innerList.map(function(item, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: item.description
                                }, index);
                            })
                        })
                    ]
                }, index);
            })
        ]
    });
};
/* harmony default export */ var PrivacyPolicyItem_PrivacyPolicyItem = (PrivacyPolicyItem);

// EXTERNAL MODULE: ./customHooks/useLocalised/useLocalised.ts + 2 modules
var useLocalised = __webpack_require__(91933);
// EXTERNAL MODULE: ./blocks/Layouts/GlobalLayout.tsx + 3 modules
var GlobalLayout = __webpack_require__(94082);
// EXTERNAL MODULE: ./data/translationKeys.ts
var translationKeys = __webpack_require__(698);
;// CONCATENATED MODULE: ./data/privacypolicy.json
var privacypolicy_namespaceObject = JSON.parse('[{"title":"1. DATA PROTECTION","list":[{"description":"Little Emperors respects your privacy and is committed to protecting your personal data. Little Emperors is committed to keeping your data safe and secure and handling it appropriately within the guidelines of the global data protection regulations (GDPR). This policy explains how we may collect information about you and then use it in order to satisfy your hotel booking requirements. It also outlines the security measures we take in order to protect your privacy and gives assurances on things that we will not do."},{"description":"When you register for membership with us, we collect some of your personal information including your name, email address, date of birth, city of residence, phone number and credit card information. We also may monitor customer search and booking patterns and site use which enables us to improve our service. Our site records your IP address at the time of booking, and we collect data for fraud prevention."},{"description":"Data protection registration: A8508065"},{"description":"Security number: CSN3685770"},{"description":"If you would like any more information, or if you’d like to contact us about our privacy policy then please email us holly@littleemperors.com."},{"description":"We may amend this policy from time to time, in which case the amended version will be published on our website. This policy applies to personal information held about individuals. It does not apply to information we hold about companies and other organisations."}]},{"title":"2. USE OF INFORMATION","list":[{"description":"We will only use your personal data when the law allows us to. We will use personal information about you for a number of purposes, including:","innerList":[{"description":"Servicing your account;"},{"description":"To deliver relevant website content and advertisements to you and measure or understand the effectiveness of the advertising we serve to you;"},{"description":"To enable you to take part in our competitions;"},{"description":"For the purpose of completing travel bookings (this includes sharing your booking information with other parties to fulfil your booking only);"},{"description":"To advise you of any changes to or problems with a hotel booking;"},{"description":"To help us administer accounts, services and products which we offer;"},{"description":"Newsletters;"},{"description":"Proactively make individualized suggestions."}]}]},{"title":"3. AMENDMENTS","list":[{"description":"You can contact us about updating or accessing your information at any time. To update or delete any of your personal information we hold, you can contact us at any time and we will address your request timely. If you do not wish to receive the members’ newsletter, you can unsubscribe at any time by contacting us or by clicking the “unsubscribe” button."}]},{"title":"4. DISCLOSURE OF INFORMATION","list":[{"description":"We do not sell or disclose information personally identifying you to other companies without your prior consent. We do not directly sell mailing lists to third parties."}]},{"title":"5. PROTECTION OF INFORMATION","list":[{"description":"We have put in place appropriate security measures to prevent your personal data from being lost, used, accessed, altered or disclosed in an unauthorised way. In addition, we limit access to your personal data to our employees who have a business need to know. We maintain strict security measures in order to protect personal information. They will only process your personal data on our instructions and they are subject to a duty of confidentiality. We follow also follow certain procedures in order to ensure compliance with the Global Data Protection Regulation. Our security policy covers encryption, password compliance, firewall and penetration testing, breach handling, employee training and security, and more."}]},{"title":"6. COOKIES","list":[{"description":"Our website uses cookies (small data files saved to your computer) to distinguish you from other users of our website, and improve how we understand you. This helps us to provide you with a good experience when you browse our website and also allows us to improve our site. Cookies are set for a number of reasons – to help you make online bookings, to help us analyse our site so we can make improvements and to help third parties advertising on the site to monitor the effectiveness of their adverts. By continuing to browse the site, you are agreeing to our use of cookies. We may use information like cookies for purposes including, but not limited to:","innerList":[{"description":"Improving your experience on our website or app; and"},{"description":"Improving our services generally."}]},{"description":"Cookies are small pieces of information that are stored on your device by your browser. These allow us to store your account information and provide features to make browsing and booking easier. You can block cookies by activating the setting on your browser that allows you to refuse the setting of all or some cookies. However, if you use your browser settings to block all cookies (including essential cookies) you may not be able to access all or parts of our site. Your web browser allows you to control which cookies your computer will and won’t accept – use the Help menu in your browser window to find out more."}]}]');
// EXTERNAL MODULE: ./blocks/DownloadApp/DownloadApp.tsx + 2 modules
var DownloadApp = __webpack_require__(31968);
;// CONCATENATED MODULE: ./pages/privacy-policy.tsx









var PrivacyPolicy = function(param) {
    var globalLayoutProps = param.globalLayoutProps;
    var privacy_policy_text = (0,useLocalised/* default */.Z)(translationKeys.privacy_policy);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(GlobalLayout/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, globalLayoutProps), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "privacy-policy-page",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "privacy-policy-page__title",
                        children: privacy_policy_text
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "privacy-policy-page__content",
                        children: privacypolicy_namespaceObject.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivacyPolicyItem_PrivacyPolicyItem, {
                                title: item.title,
                                privacyPolicies: item.list
                            }, index);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DownloadApp/* default */.Z, {})
        ]
    }));
};
var __N_SSG = true;
/* harmony default export */ var privacy_policy = (PrivacyPolicy);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [48,5675,210,9510,9774,2888,179], function() { return __webpack_exec__(94217); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);